import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { answerScriptStrings } from "@/lib/answerScript/i18n";

// "Answer script" on the interview's start screen (2026-11-04): shown only when the
// server says this account may open it (admins, and beta testers the admin switched
// on). Opens the script in a new tab.
export function AnswerScriptButton({ sessionId, lang, className = "" }) {
  const [available, setAvailable] = useState(false);
  useEffect(() => {
    let alive = true;
    if (!sessionId) return undefined;
    api.get(`/sessions/${encodeURIComponent(sessionId)}/answer-script/available`)
      .then(({ data }) => alive && setAvailable(Boolean(data?.available)))
      .catch(() => {});
    return () => { alive = false; };
  }, [sessionId]);
  if (!available) return null;
  const s = answerScriptStrings(lang);
  return (
    <a href={`/answer-script/${encodeURIComponent(sessionId)}`} target="_blank" rel="noopener noreferrer"
      title={s.buttonHint} data-testid="answer-script-button"
      className={`inline-flex items-center rounded-full border border-[color:var(--brand)] px-4 py-2 text-sm text-[color:var(--brand)] hover:bg-[color:var(--brand)]/10 ${className}`}>
      {s.button}
    </a>
  );
}
